(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["gallery"] && !Shopify.designMode) return;
  try {
    var $galleries = document.querySelectorAll('.gallery');
    $galleries.forEach(function($gallery) {
        var $gallerList = $gallery.querySelector('.gallery-list');
        var $galleryItems = $gallery.querySelectorAll('.gallery-item');
        var galleryItemsCount = $galleryItems.length        
        var $galleryPreviewNextImage = $gallery.querySelector('.gallery-preview-next');
        var $galleryPreviewUpcomingImage = $gallery.querySelector('.gallery-preview-upcoming');
        var galleryPreviousIndex = false;
        var galleryActiveIndex  = false;
        var galleryNextIndex = false;
        var galleryUpcomingIndex = false;
        var $galleryPreviousItem;
        var $galleryActiveItem;
        var $galleryNextItem;
        var $galleryUpcomingItem;
        var galleryNextPreviewImageUrl;
        var galleryUpcomingPreviewImageUrl;
        var galleryTransitionMs = 800;

        function galleryForceReflow() {
            $gallery.offsetWidth;
        }

        function galleryApplyPreviewImages() {
            galleryNextPreviewImageUrl = $galleryNextItem.getAttribute('data-preview-image-url');
            galleryUpcomingPreviewImageUrl = $galleryUpcomingItem.getAttribute('data-preview-image-url');
            $galleryPreviewNextImage.src = galleryNextPreviewImageUrl;
            $galleryPreviewUpcomingImage.src = galleryUpcomingPreviewImageUrl;

            /*
            if (galleryNextIndex === 1) {
                $galleryPreviewNextImage.classList.add('gallery-image--blur');
            } else {
                $galleryPreviewNextImage.classList.remove('gallery-image--blur');
            }

            if (galleryUpcomingIndex === 1) {
                $galleryPreviewUpcomingImage.classList.add('gallery-image--blur');
            } else {
                $galleryPreviewUpcomingImage.classList.remove('gallery-image--blur');
            }
            */
        }

        function galleryUpdate() {
            if ($galleryPreviousItem) {
                $galleryPreviousItem.classList.remove('is-previous');
            }

            if ($galleryActiveItem) {
                $galleryActiveItem.classList.remove('is-active');
            }

            if ($galleryNextItem) {
                $galleryNextItem.classList.remove('is-next');
            }

            if ($galleryUpcomingItem) {
                $galleryUpcomingItem.classList.remove('is-upcoming');
            }

            $galleryPreviousItem = $galleryItems[galleryPreviousIndex];
            $galleryActiveItem = $galleryItems[galleryActiveIndex];
            $galleryNextItem = $galleryItems[galleryNextIndex];
            $galleryUpcomingItem = $galleryItems[galleryUpcomingIndex];

            $galleryPreviousItem.classList.add('is-previous');
            $galleryActiveItem.classList.add('is-active');
            $galleryNextItem.classList.add('is-next');
            $galleryUpcomingItem.classList.add('is-upcoming');

            $gallery.setAttribute('data-gallery-active-index', galleryActiveIndex);
            galleryApplyPreviewImages();

            console.log('>>> GALLERY UPDATE', {
                galleryActiveIndex,
                galleryPreviousIndex,
                galleryNextIndex,
                galleryUpcomingIndex,
                galleryNextPreviewImageUrl,
                galleryUpcomingPreviewImageUrl,
            });
        }

        function galleryInit() {
            for (var i = 0; i < galleryItemsCount; i++) {
                if ($galleryItems[i].classList.contains('is-active')) {
                    if (galleryActiveIndex === false) {
                        galleryActiveIndex = i;
                    } else {
                        $galleryItems[i].classList.remove('is-active');
                    }
                }

                if ($galleryItems[i].classList.contains('is-previous')) {
                    if (galleryPreviousIndex === false) {
                        galleryPreviousIndex = i;
                    } else {
                        $galleryItems[i].classList.remove('is-previous');
                    }
                }
                
                if ($galleryItems[i].classList.contains('is-next')) {
                    if (galleryNextIndex === false) {
                        galleryNextIndex = i;
                    } else {
                        $galleryItems[i].classList.remove('is-next');
                    }
                }

                if ($galleryItems[i].classList.contains('is-upcoming')) {
                    if (galleryUpcomingIndex === false) {
                        galleryUpcomingIndex = i;
                    } else {
                        $galleryItems[i].classList.remove('is-upcoming');
                    }
                }
            }

            $gallery.classList.add('is-snapping');
            galleryUpdate();
            galleryForceReflow();
            $gallery.classList.remove('is-snapping');
        }

        function galleryNext() {
            if ($gallery.classList.contains('is-transitioning')) {
                return;
            }

            var galleryCurrentIndex = parseInt($gallery.getAttribute('data-gallery-active-index', 0));
            var $exitingItem = $galleryPreviousItem;

            galleryPreviousIndex = galleryCurrentIndex;
            galleryActiveIndex = galleryCurrentIndex + 1;
            galleryNextIndex = galleryCurrentIndex + 2;
            galleryUpcomingIndex = galleryCurrentIndex + 3;

            if (galleryActiveIndex >= galleryItemsCount) {
                galleryActiveIndex = 0;
                galleryNextIndex = 1;
                galleryUpcomingIndex = 2;
            }

            if (galleryNextIndex >= galleryItemsCount) {
                galleryNextIndex = 0;
                galleryUpcomingIndex = 1;
            }

            if (galleryUpcomingIndex >= galleryItemsCount) {
                galleryUpcomingIndex = 0;
            }

            $gallery.classList.add('is-transitioning');

            if ($exitingItem) {
                $exitingItem.classList.remove('is-previous');
                $exitingItem.classList.add('is-exiting');
            }

            if ($galleryActiveItem) {
                $galleryActiveItem.classList.remove('is-active');
                $galleryActiveItem.classList.add('is-previous');
            }

            if ($galleryNextItem) {
                $galleryNextItem.classList.remove('is-next');
            }

            if ($galleryUpcomingItem) {
                $galleryUpcomingItem.classList.remove('is-upcoming');
            }

            $galleryPreviousItem = $galleryItems[galleryPreviousIndex];
            $galleryActiveItem = $galleryItems[galleryActiveIndex];
            $galleryNextItem = $galleryItems[galleryNextIndex];
            $galleryUpcomingItem = $galleryItems[galleryUpcomingIndex];

            $galleryPreviousItem.classList.add('is-previous');
            $galleryNextItem.classList.add('is-next');
            $galleryUpcomingItem.classList.add('is-upcoming');
            $gallery.setAttribute('data-gallery-active-index', galleryActiveIndex);

            setTimeout(function() {
                $gallery.classList.add('is-snapping');
                galleryForceReflow();
                $gallery.classList.remove('is-transitioning');

                if ($exitingItem) {
                    $exitingItem.classList.remove('is-exiting');
                }

                $galleryActiveItem.classList.add('is-active');
                galleryApplyPreviewImages();

                galleryForceReflow();
                $gallery.classList.remove('is-snapping');
            }, galleryTransitionMs);
        }

        galleryInit();
        $gallery.addEventListener('click', function() {
            galleryNext();
        });
    });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-shipping"] && !Shopify.designMode) return;
  try {
    const PRICE_PLACEHOLDER = '__PRICE__';
  const FETCH_RATES_MAX_ATTEMPTS = 8;
  const FETCH_RATES_ATTEMPT_DELAY_MS = 400;

  let cartLock = Promise.resolve();
  let cartLockCount = 0;

  // Locale-aware Cart API root, e.g. "/" or "/en-gb/".
  function rootUrl() {
    if (window.Shopify && Shopify.routes && Shopify.routes.root) {
      return Shopify.routes.root;
    }
    return '/';
  }

  // Build a Cart API URL from a path like "cart.js".
  function cartUrl(path) {
    return rootUrl() + path;
  }

  function sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  // Queue cart mutations so rate previews cannot overlap, and so add-to-cart
  // waits until the shopper's real cart has been restored.
  function withCartLock(fn) {
    cartLockCount += 1;
    const run = cartLock.then(fn, fn);
    cartLock = run.then(
      () => {
        cartLockCount -= 1;
      },
      () => {
        cartLockCount -= 1;
      }
    );
    return run;
  }

  // Format a cent amount with thousands/decimal separators.
  function formatWithDelimiters(number, precision, thousands, decimal) {
    const safePrecision = precision == null ? 2 : precision;
    const safeThousands = thousands == null ? ',' : thousands;
    const safeDecimal = decimal == null ? '.' : decimal;
    if (number == null || Number.isNaN(number)) {
      return '0';
    }
    const value = (number / 100.0).toFixed(safePrecision);
    const parts = value.split('.');
    const dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + safeThousands);
    const remainder = parts[1] ? safeDecimal + parts[1] : '';
    return dollars + remainder;
  }

  function customerCurrency(config) {
    if (window.Shopify && Shopify.currency && Shopify.currency.active) {
      return Shopify.currency.active;
    }
    return config.customerCurrency;
  }

  function storefrontLocale(config) {
    if (window.Shopify && Shopify.locale) {
      return Shopify.locale;
    }
    return config.locale;
  }

  // Cart.js `currency` is the presentment currency for Cart API prices, including shipping rates.
  function presentmentCurrency(config, apiCurrency) {
    return apiCurrency || customerCurrency(config);
  }

  // Presentment currency uses Intl when it differs from the shop currency.
  // Otherwise use the shop money format (the same placeholders as Liquid's money filter).
  function formatMoney(cents, config, apiCurrency) {
    const currency = presentmentCurrency(config, apiCurrency);
    const shopCurrency = config.shopCurrency;
    const canUseIntl =
      typeof Intl !== 'undefined' &&
      typeof Intl.NumberFormat === 'function' &&
      currency &&
      shopCurrency &&
      String(currency).toUpperCase() !== String(shopCurrency).toUpperCase();

    if (canUseIntl) {
      try {
        return new Intl.NumberFormat(storefrontLocale(config), {
          style: 'currency',
          currency: currency,
        }).format(cents / 100);
      } catch (error) {
        console.error('Product shipping: Intl.NumberFormat failed', error);
      }
    }

    const tokenOpen = '{' + '{';
    const tokenClose = '}' + '}';
    const placeholderRegex = new RegExp(tokenOpen + '\\s*(\\w+)\\s*' + tokenClose);
    const symbol = config.currencySymbol || '';
    const formatString = config.moneyFormat || symbol + tokenOpen + 'amount' + tokenClose;
    const match = formatString.match(placeholderRegex);
    if (!match) {
      return String(cents / 100);
    }

    let value = '';
    switch (match[1]) {
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 2, "'", '.');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', ',');
        break;
      case 'amount_with_period_and_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', '.');
        break;
      default:
        value = formatWithDelimiters(cents, 2);
    }

    return formatString.replace(placeholderRegex, value);
  }

  // Cart shipping rates return prices as decimal strings, e.g. "5.00".
  function priceToCents(price) {
    return Math.round(parseFloat(price, 10) * 100);
  }

  // Tokens come from the product section setting (pipe-separated, already lowercased).
  function isDeliverableRate(rate, tokens) {
    if (!tokens || !tokens.length) {
      return true;
    }
    const name = String(rate.name || '').toLowerCase();
    const source = String(rate.source || '').toLowerCase();
    for (let i = 0; i < tokens.length; i += 1) {
      const token = tokens[i];
      if (name.includes(token) || source.includes(token)) {
        return false;
      }
    }
    return true;
  }

  // Query string expected by /cart/prepare_shipping_rates.json and /cart/async_shipping_rates.json.
  function shippingQuery(address) {
    const params = new URLSearchParams();
    if (address.country) {
      params.set('shipping_address[country]', address.country);
    }
    if (address.province) {
      params.set('shipping_address[province]', address.province);
    }
    if (address.zip) {
      params.set('shipping_address[zip]', address.zip);
    }
    return params.toString();
  }

  // prepare_shipping_rates / async_shipping_rates may return an empty body or "null".
  async function parseJson(response) {
    const text = await response.text();
    if (!text || text === 'null') {
      return null;
    }
    return JSON.parse(text);
  }

  function shippingRatesFromPayload(payload) {
    if (payload && Array.isArray(payload.shipping_rates)) {
      return payload.shipping_rates;
    }
    return null;
  }

  // HTTP errors and Shopify bodies like { error: [...] } stop polling; null means not ready.
  async function readShippingRatesResponse(response) {
    let payload = null;
    try {
      payload = await parseJson(response);
    } catch (error) {
      return { error: error };
    }
    if (payload && payload.error) {
      return { error: payload.error };
    }
    if (!response.ok) {
      return { error: payload || response.status + ' ' + response.statusText };
    }
    const rates = shippingRatesFromPayload(payload);
    if (rates) {
      return { rates: rates };
    }
    return {};
  }

  async function requestShippingRates(url) {
    try {
      const response = await fetch(url, {
        headers: { Accept: 'application/json' },
      });
      return await readShippingRatesResponse(response);
    } catch (error) {
      return { error: error };
    }
  }

  async function fetchCart() {
    const response = await fetch(cartUrl('cart.js'), {
      headers: { Accept: 'application/json' },
    });
    if (!response.ok) {
      throw new Error('cart');
    }
    return response.json();
  }

  // Capture enough line-item data to restore the shopper's cart after a preview.
  function snapshotItems(cart) {
    return (cart.items || []).map((item) => {
      const snapshot = {
        id: item.variant_id,
        quantity: item.quantity,
      };
      if (item.properties && Object.keys(item.properties).length) {
        snapshot.properties = item.properties;
      }
      if (item.selling_plan_allocation && item.selling_plan_allocation.selling_plan) {
        snapshot.selling_plan = item.selling_plan_allocation.selling_plan.id;
      }
      return snapshot;
    });
  }

  // Shipping rates are always calculated from the current cart, so we temporarily
  // replace it with a preview, then restore the snapshot afterwards.
  async function setCartItems(items) {
    await fetch(cartUrl('cart/clear.js'), {
      method: 'POST',
      headers: { Accept: 'application/json' },
    });
    if (!items.length) {
      return;
    }
    const response = await fetch(cartUrl('cart/add.js'), {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ items: items }),
    });
    if (!response.ok) {
      throw new Error('cart_add');
    }
  }

  // Ask Shopify to calculate rates for the current cart, then poll until ready.
  async function fetchShippingRates(address) {
    const query = shippingQuery(address);
    const prepareUrl = cartUrl('cart/prepare_shipping_rates.json') + '?' + query;
    const asyncUrl = cartUrl('cart/async_shipping_rates.json') + '?' + query;

    await fetch(prepareUrl, { method: 'POST' });

    for (let attempt = 0; attempt < FETCH_RATES_MAX_ATTEMPTS; attempt += 1) {
      const result = await requestShippingRates(asyncUrl);
      if (result.rates) {
        return result.rates;
      }
      if (result.error) {
        console.error('Product shipping: cart/async_shipping_rates.json failed', result.error);
        break;
      }
      await sleep(FETCH_RATES_ATTEMPT_DELAY_MS);
    }

    const fallback = await requestShippingRates(cartUrl('cart/shipping_rates.json') + '?' + query);
    if (fallback.rates) {
      return fallback.rates;
    }
    if (fallback.error) {
      console.error('Product shipping: cart/shipping_rates.json failed', fallback.error);
    }
    return [];
  }

  function cheapestDeliverableCents(rates, tokens) {
    const prices = rates
      .filter((rate) => isDeliverableRate(rate, tokens))
      .map((rate) => priceToCents(rate.price));
    if (!prices.length) {
      return null;
    }
    return Math.min(...prices);
  }

  function currencyFromRates(rates) {
    if (!rates) {
      return null;
    }
    for (let i = 0; i < rates.length; i += 1) {
      if (rates[i].currency) {
        return rates[i].currency;
      }
    }
    return null;
  }

  function itemsIncludeVariant(items, variantId) {
    return items.some((item) => Number(item.id) === Number(variantId));
  }

  // Ensure the preview cart contains this variant so rates apply to adding it.
  function itemsWithVariant(items, variantId) {
    if (itemsIncludeVariant(items, variantId)) {
      return items;
    }
    return items.concat([{ id: variantId, quantity: 1 }]);
  }

  function isVariantOnlyItems(items, variantId) {
    return items.length === 1 && Number(items[0].id) === Number(variantId);
  }

  // Product-only rates supply the "from" price. If that is not free, also check
  // cart + product so a free-shipping discount unlocked by adding it is caught.
  async function estimateShipping(variantId, address, tokens) {
    const cart = await fetchCart();
    const originalItems = snapshotItems(cart);
    try {
      await setCartItems([{ id: variantId, quantity: 1 }]);
      const productRates = await fetchShippingRates(address);
      const productCents = cheapestDeliverableCents(productRates, tokens);
      let free = productCents === 0;
      const currency = currencyFromRates(productRates) || cart.currency || null;

      if (!free && originalItems.length && !isVariantOnlyItems(originalItems, variantId)) {
        await setCartItems(itemsWithVariant(originalItems, variantId));
        if (cheapestDeliverableCents(await fetchShippingRates(address), tokens) === 0) {
          free = true;
        }
      }

      return { free, cents: productCents, currency: currency };
    } finally {
      await setCartItems(originalItems);
    }
  }

  function readConfig(el) {
    const script = el.querySelector('script.js-product-shipping-config');
    if (!script) {
      return null;
    }
    try {
      return JSON.parse(script.textContent);
    } catch (error) {
      return null;
    }
  }

  function renderLabel(el, config, result) {
    if (result.cents == null) return;
    const label = el.querySelector('.js-product-shipping-label');
    if (!label) return;
    if (result.free) {
      label.textContent = config.strings.free;
    } else {
      const price = formatMoney(result.cents, config, result.currency);
      label.textContent = config.strings.from.replace(PRICE_PLACEHOLDER, price);
    }
    el.hidden = false;
  }

  // Re-estimate when the variant changes, and hold submit until the cart restore finishes.
  function bindForm(el, config) {
    const form = el.closest('form');
    if (!form || form.dataset.productShippingBound === 'true') {
      return;
    }
    form.dataset.productShippingBound = 'true';

    form.addEventListener('change', (event) => {
      if (event.target.name !== 'id') {
        return;
      }
      const variantId = Number(event.target.value);
      updateShippingInfo(el, config, variantId);
    });

    form.addEventListener('submit', (event) => {
      if (cartLockCount === 0) {
        return;
      }
      event.preventDefault();
      cartLock.then(() => {
        HTMLFormElement.prototype.submit.call(form);
      });
    });
  }

  function updateShippingInfo(el, config, variantId) {
    const requiresShipping =
      config.variants && Object.prototype.hasOwnProperty.call(config.variants, variantId)
        ? config.variants[variantId]
        : config.requiresShipping;

    if (!requiresShipping || !config.address || !config.address.country) {
      el.hidden = true;
      return;
    }

    withCartLock(() =>
      estimateShipping(
        variantId,
        config.address,
        Array.isArray(config.nonDeliverableTokens) ? config.nonDeliverableTokens : []
      )
    )
      .then((result) => {
        renderLabel(el, config, result);
      })
      .catch(() => {
        el.hidden = true;
      });
  }

  function init() {
    document.querySelectorAll('.js-product-shipping').forEach((el) => {
      const config = readConfig(el);
      if (!config) {
        return;
      }
      bindForm(el, config);
      const form = el.closest('form');
      const selected = form ? form.querySelector('[name="id"]') : null;
      const variantId = selected ? Number(selected.value) : Number(config.variantId);
      updateShippingLabel(el, config, variantId);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["stepper"] && !Shopify.designMode) return;
  try {
    function stepperInit($stepper)
    {
        var $input = $stepper.querySelector('.stepper-input');
        var $decreaseBtns = $stepper.querySelectorAll('.stepper-btn--decrease');
        var $increaseBtns = $stepper.querySelectorAll('.stepper-btn--increase');
        var $submitBtns = $stepper.querySelectorAll('.stepper-submit');
        var $form = $stepper.closest('form');

        console.log('>>>> stepper init', {
            stepper: $stepper,
            form: $form,
            input: $input,
            decreaseBtns: $decreaseBtns,
            increaseBtns: $increaseBtns,
            submitBtns: $submitBtns,
        });

        $decreaseBtns.forEach(function($decreaseBtn) {
            $decreaseBtn.style.display = 'inline-block';
            $decreaseBtn.addEventListener('click', function(event) {
                console.log('>>>> stepper stepDown', $stepper.id, $decreaseBtn);
                $input.stepDown();
                $form.submit();
            });
        });

        $increaseBtns.forEach(function($increaseBtn) {
            $increaseBtn.style.display = 'inline-block';
            $increaseBtn.addEventListener('click', function(event) {
                console.log('>>>> stepper stepUp', $stepper.id, $increaseBtn);
                $input.stepUp();
                $form.submit();
            });
        });
    }

    var $steppers = document.querySelectorAll('.stepper');
    $steppers.forEach(function($stepper) {
        stepperInit($stepper);
    });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["video"] && !Shopify.designMode) return;
  try {
    function formatVideoTime(seconds) {
      var total = Math.round(Number(seconds) || 0);
      var minutes = Math.floor(total / 60);
      var rest = total % 60;
      return String(minutes).padStart(2, '0') + ':' + String(rest).padStart(2, '0');
    }

    function setPlaybackState(root, playing) {
      var playbackBtn = root.querySelector('.js-videoplayer-playback');
      root.classList.toggle('is-playing', playing);
      root.classList.toggle('is-paused', !playing);
      if (playbackBtn) {
        playbackBtn.setAttribute('aria-label', playing ? root.dataset.labelPause : root.dataset.labelPlay);
      }
    }

    function setMuteState(root, muted) {
      var volumeBtn = root.querySelector('.js-videoplayer-volume');
      root.classList.toggle('is-muted', muted);
      root.classList.toggle('is-unmuted', !muted);
      if (volumeBtn) {
        volumeBtn.setAttribute('aria-label', muted ? root.dataset.labelUnmute : root.dataset.labelMute);
      }
    }

    function setFullscreenState(root, fullscreen) {
      var fullscreenBtn = root.querySelector('.js-videoplayer-fullscreen');
      root.classList.toggle('is-fullscreen', fullscreen);
      if (fullscreenBtn) {
        fullscreenBtn.setAttribute(
          'aria-label',
          fullscreen ? root.dataset.labelExitFullscreen : root.dataset.labelEnterFullscreen
        );
      }
    }

    function bindVideoPlayer(root, player, state) {
      var toggleBtn = root.querySelector('.js-videoplayer-toggle');
      var playbackBtn = root.querySelector('.js-videoplayer-playback');
      var volumeBtn = root.querySelector('.js-videoplayer-volume');
      var fullscreenBtn = root.querySelector('.js-videoplayer-fullscreen');
      var timeEl = root.querySelector('.js-videoplayer-time');
      var metaEl = root.querySelector('.js-videoplayer-meta');
      var media = player.media || root.querySelector('video');
      var progressBar = player.elements.progressBar;
      var duration = 0;
      var hasUnmutedOnce = false;
      var overlayEls = [playbackBtn, volumeBtn, fullscreenBtn, metaEl];

      function updateProgress() {
        if (!media || !duration) return;
        var current = media.currentTime || 0;
        var percent = (current / duration) * 100;
        if (progressBar) {
          progressBar.value = String(percent);
          progressBar.style.setProperty('--vlite-progressValue', percent + '%');
        }
        if (timeEl) {
          var formatted = formatVideoTime(current);
          if (timeEl.textContent !== formatted) timeEl.textContent = formatted;
        }
      }

      function stopProgressLoop() {
        if (state.rafId) {
          cancelAnimationFrame(state.rafId);
          state.rafId = 0;
        }
      }

      function startProgressLoop() {
        stopProgressLoop();
        function tick() {
          updateProgress();
          if (root.classList.contains('is-playing')) {
            state.rafId = requestAnimationFrame(tick);
          }
        }
        state.rafId = requestAnimationFrame(tick);
      }

      function revealFullscreenControls() {
        root.classList.add('is-controls-visible');
        if (state.idleTimer) clearTimeout(state.idleTimer);
        state.idleTimer = setTimeout(function() {
          root.classList.remove('is-controls-visible');
          state.idleTimer = 0;
        }, 3000);
      }

      function onFullscreenActivity() {
        if (!root.classList.contains('is-fullscreen')) return;
        revealFullscreenControls();
      }

      function enterFullscreenUi() {
        var alreadyFullscreen = root.classList.contains('is-fullscreen');
        setFullscreenState(root, true);
        if (!alreadyFullscreen) {
          document.addEventListener('mousemove', onFullscreenActivity);
          document.addEventListener('keydown', onFullscreenActivity);
        }
        revealFullscreenControls();
      }

      function exitFullscreenUi() {
        setFullscreenState(root, false);
        root.classList.remove('is-controls-visible');
        document.removeEventListener('mousemove', onFullscreenActivity);
        document.removeEventListener('keydown', onFullscreenActivity);
        if (state.idleTimer) {
          clearTimeout(state.idleTimer);
          state.idleTimer = 0;
        }
      }

      state.clearFullscreenUi = exitFullscreenUi;

      if (player.elements.container) {
        overlayEls.forEach(function(el) {
          if (el) player.elements.container.appendChild(el);
        });
      }

      player.getDuration().then(function(value) {
        duration = value || 0;
        updateProgress();
      });

      setPlaybackState(root, !player.elements.outerContainer.classList.contains('v-paused'));
      setMuteState(root, player.isMuted);
      if (root.classList.contains('is-playing')) startProgressLoop();

      player.on('play', function() {
        setPlaybackState(root, true);
        startProgressLoop();
      });

      player.on('pause', function() {
        setPlaybackState(root, false);
        stopProgressLoop();
        updateProgress();
      });

      player.on('volumechange', function() {
        setMuteState(root, player.isMuted);
      });

      player.on('enterfullscreen', enterFullscreenUi);
      player.on('exitfullscreen', exitFullscreenUi);

      if (media) {
        media.addEventListener('seeked', updateProgress);
      }

      if (playbackBtn) {
        playbackBtn.addEventListener('click', function() {
          if (root.classList.contains('is-paused')) {
            player.play();
          } else {
            player.pause();
          }
        });
      }

      if (volumeBtn) {
        volumeBtn.addEventListener('click', function() {
          if (root.classList.contains('is-muted')) {
            if (!hasUnmutedOnce) {
              hasUnmutedOnce = true;
              player.seekTo(0);
              player.unMute();
              player.play();
              return;
            }
            player.unMute();
            return;
          }
          player.mute();
        });
      }

      if (fullscreenBtn) {
        fullscreenBtn.addEventListener('click', function() {
          if (player.isFullScreen) {
            player.exitFullscreen();
          } else {
            player.requestFullscreen();
          }
        });
      }

      if (toggleBtn) {
        toggleBtn.addEventListener('click', function() {
          if (root.classList.contains('is-paused')) {
            player.play();
          } else {
            player.pause();
          }
        });
      }
    }

    function initVideoPlayer(root) {
      if (typeof window.Vlitejs !== 'function') return;
      if (root.classList.contains('is-initialized')) return;
      var video = root.querySelector('video');
      var closeBtn = root.querySelector('.js-videoplayer-close');
      var state = { vlite: null, rafId: 0, idleTimer: 0, clearFullscreenUi: null };
      if (!video) return;

      root.classList.add('is-initialized');

      root.addEventListener('mouseenter', function() {
        root.classList.add('is-hover');
      });
      root.addEventListener('mouseleave', function() {
        root.classList.remove('is-hover');
      });

      if (closeBtn) {
        closeBtn.addEventListener('click', function() {
          if (state.rafId) cancelAnimationFrame(state.rafId);
          if (state.clearFullscreenUi) state.clearFullscreenUi();
          if (state.vlite) state.vlite.destroy();
          root.remove();
        });
      }

      state.vlite = new window.Vlitejs(video, {
        options: {
          autoplay: true,
          muted: true,
          loop: true,
          playsinline: true,
          controls: true,
          playPause: false,
          progressBar: true,
          time: false,
          volume: false,
          fullscreen: false,
          bigPlay: false,
          autoHide: false
        },
        onReady: function(player) {
          bindVideoPlayer(root, player, state);
        }
      });
    }

    function initAllVideoPlayers() {
      document.querySelectorAll('.js-videoplayer').forEach(initVideoPlayer);
    }

    initAllVideoPlayers();
    document.addEventListener('DOMContentLoaded', initAllVideoPlayers);
  } catch(e) { console.error(e); }
})();

})();
